import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { FieldSkeleton } from '../../../subcomponents/form/field/field/subcomponents/skeleton';
import { PasswordField } from '../../../subcomponents/form/field/password/password-field';
import { getFieldClassName, getFieldId } from '../../../subcomponents/form/field/utils/field-attribute-utils';
import { InvalidFieldNameError } from '../../../types/invalid-field-name-error';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { MemberPasswordResetFormContextInstance } from '../member-password-reset-form/types/context';
import { MemberPasswordResetFormFieldName } from './types/name';
import { defaultMemberPasswordResetFormFieldPropsProvider, memberPasswordResetFormFieldPropsValidator } from './types/props';
const b = bemClassBuilder('v-member-password-reset-form-field');
const MemberPasswordResetFormField = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { name, displayText } = props;
    const { onChange, validationConfig, validator, loading, formData, validationResult, disabled } = useContext(MemberPasswordResetFormContextInstance);
    if (loading) {
        return enableSkeletonLoadingIndicators ? _jsx(FieldSkeleton, { showLabel: !!displayText.label }) : null;
    }
    switch (name) {
        case MemberPasswordResetFormFieldName.Password: {
            const key = 'password';
            return (_jsx(PasswordField, { id: getFieldId(b, key), name: key, value: formData[key], className: getFieldClassName(b, key), displayText: displayText, error: validationResult.validationErrors[key], validationConfig: validationConfig[key], validate: newValue => validator.validateField(key, newValue), onChangeValue: newValue => onChange(key, newValue), disabled: disabled }));
        }
        default:
            throw new InvalidFieldNameError('MemberPasswordResetFormField', name);
    }
});
MemberPasswordResetFormField.displayName = 'MemberPasswordResetFormField';
/**
 * The **Member Password Reset Form Field** component allows a customer to reset their loyalty account password using either their **email**
 * or **username**.
 */
export const MemberPasswordResetFormFieldComponent = withComponentWrapper(MemberPasswordResetFormField, defaultMemberPasswordResetFormFieldPropsProvider, memberPasswordResetFormFieldPropsValidator);
